import { memo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { addFeatureTag, removeFeatureTag } from "../../features/catalog/catalogSlice";

export const FeatureTag = memo(({ tag }) => {
  const dispatch = useDispatch();
  const selectedFeatureTags = useSelector((state) => state.catalog.selectedFeatureTags);

  const onTagClick = useCallback(() => {
    if (selectedFeatureTags.includes(tag.id)) {
      dispatch(removeFeatureTag(tag.id));
    } else {
      dispatch(addFeatureTag(tag.id));
    }
  }, [dispatch, tag, selectedFeatureTags]);

  return (
    <div className={`feature-tag ${selectedFeatureTags.includes(tag.id) ? 'selected' : ''}`} onClick={onTagClick}>
      {/* <div className="feature-tag__icon-outer">
        <img className="feature-tag__icon feature-tag__icon--plus" src="/image/games/filters/feature-tags/plus.svg" />
        <img className="feature-tag__icon feature-tag__icon--plus-hover" src="/image/games/filters/feature-tags/plus-hover.svg" />
        <img className="feature-tag__icon feature-tag__icon--checked" src="/image/games/filters/feature-tags/check.svg" />
      </div> */}
      <span className="feature-tag__title">{tag.title}</span>
    </div>
  )
});

function FeatureTags() {
  const featureTags = useSelector((state) => state.catalog.featureTags);
  const { t, i18n } = useTranslation();

  return (
    <div className="feature-tags">
      <h2 className="games-catalog__subtitle">{t('tags')}</h2>
      <div className="feature-tags__list">
        {featureTags.map((tag) => <FeatureTag key={tag.id} tag={tag} />)}
      </div>
    </div>
  );
}

export default FeatureTags;
